export const footerNav = [
  {
    path: '/terms',
    label: 'Terms',
  }
];
